import { render, staticRenderFns } from "./ListPromoCodes.vue?vue&type=template&id=06ad63e3&scoped=true"
import script from "./ListPromoCodes.vue?vue&type=script&lang=ts"
export * from "./ListPromoCodes.vue?vue&type=script&lang=ts"
import style0 from "./ListPromoCodes.vue?vue&type=style&index=0&id=06ad63e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad63e3",
  null
  
)

export default component.exports